import { useBreadcrumbsContext } from "./useBreadcrumbsContext.js";
import "react";
import { Breadcrumbs } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/components/Breadcrumbs/BreadcrumbsSlot.tsx
function BreadcrumbsSlot() {
	const { breadcrumbs, onBack } = useBreadcrumbsContext();
	if (!breadcrumbs) return null;
	return /* @__PURE__ */ jsx(Breadcrumbs, {
		onBackClick: breadcrumbs.length > 1 ? onBack : void 0,
		children: breadcrumbs
	});
}
//#endregion
export { BreadcrumbsSlot };

//# sourceMappingURL=BreadcrumbsSlot.js.map